import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const massNotificationUrl = `${SERVER_API}/notification/mass-notifications`;

export const MASS_NOTIFICATION = {
  ...generateCrudEndpoints(massNotificationUrl),
  UPDATE_USERS(id: number): IEndpointData {
    return {
      method: 'PUT',
      url: `${massNotificationUrl}/${id.toString()}/users`,
    };
  },
  COPY(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${massNotificationUrl}/${id.toString()}/copy`,
    };
  },
  SEND(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${massNotificationUrl}/${id.toString()}/send`,
    };
  },
};
